export default __webpack_public_path__ + "static/media/brainhi_logo_white.b693eb3d.svg";